import BackTop from './BackTop';

export type { BackTopProps, BackTopCssVars } from './BackTop';

export default BackTop;
